<template>
  <div class="head-nav-content">
    <div
      class="item-content"
      v-for="(item, index) in navList"
      v-show="item.show"
      :key="index"
      @click="selectedPage(index, item)"
    >
      <div :class="[
          'name-content',
          activeIndex === index ? 'active' : '',
          index === 0 ? 'longtxt' : ''
        ]">
        {{ item.name }}
      </div>
      <img
        v-show="activeIndex === index"
        class="head-nav-content__barimg"
        :src="barLineImg"
        alt=""
      >
    </div>
  </div>
</template>

<script>
import apiService from '../../assets/js/api'
import * as dd from 'dingtalk-jsapi'
import {

  Dialog

} from 'vant'
export default {
  name: '',
  data () {
    return {
      hasJoinIn: false,
      activeIndex: 0,
      barLineImg: './Icon/linebar.png',
      navList: [
        { name: '红黑榜', url: '/rank', show: false },
        { name: '今日资讯', url: '/news', show: false },
        { name: '营销', url: '/', show: false },
        { name: '榜单', url: '/scoreList', show: false },
        { name: '营销-海外', url: '/marketAbroad', show: false },
        { name: '财务', url: '/finance', show: false },
        { name: '生产', url: '/production', show: false }
      ]
    }
  },
  computed: {
    navIndex () {
      return this.$store.state.navIndex
    },
    routerIndex () {
      return this.$route.path
    },
    hasEnterNewsDatail () {
      return this.$store.state.hasEnterNewsDatail
    }
  },
  watch: {
    routerIndex (val) {
      if (val === '/news') {
        if (this.hasEnterNewsDatail && !this.$store.state.isOpenNewsDetail) {
          this.isAuthority()
        }
      }
      if (val === '/rank') {
        this.activeIndex = 0
        this.$store.commit('updateNavIndex', 0)
      } else if (val === '/') {
        this.activeIndex = 2
        this.$store.commit('updateNavIndex', 2)
      } else if (val === '/scoreList') {
        this.activeIndex = 3
        this.$store.commit('updateNavIndex', 3)
      } else if (val === '/marketAbroad') {
        this.activeIndex = 4
        this.$store.commit('updateNavIndex', 4)
      } else if (val === '/finance') {
        this.activeIndex = 5
        this.$store.commit('updateNavIndex', 5)
      } else if (val === '/production') {
        this.activeIndex = 6
        this.$store.commit('updateNavIndex', 6)
      } else if (val === '/news') {
        if (this.$store.state.hasEnterNewsDatail) {
          this.isAuthority()
        }
        // this.activeIndex = 1
        // this.$store.commit('updateNavIndex', 1)
      }
      // this.$store.commit('updateInitDateStr', true)
    }
  },
  methods: {
    selectedPage (index, item) {
      this.activeIndex = index
      this.$store.commit('updateUnKeepAliveName', null)
      this.$store.commit('updateNavIndex', index)
      this.$store.commit('updateInitDateStr', true)
      this.$store.commit('updateProductTab', 0)
      this.$router.replace({ path: item.url, query: { isRouterReplace: true } })
    },
    async isAuthority () {
      let { __statusCode, data } = await apiService.getDataFromInterface(
        apiService.getAuth
      )
      if (__statusCode === '1') {
        // data = ['GWM_DD_JYFX_NEWS', 'GWM_DD_JYFX_YX', 'GWM_DD_JYFX_CW', 'GWM_DD_JYFX_SC']

        if (data.length === 0) {
          Dialog.alert({
            title: '提示',
            message: '当前用户无权限，请退出'
          }).then(() => {
            // on close
            dd.biz.navigation.close()
          })
        }

        if (this.$store.state.isOpenNewsDetail && data.includes('GWM_DD_JYFX_NEWS')) {
          if (!this.hasEnterNewsDatail) {
            this.selectedPage(1, this.navList[1])
          }
        }
        if (data.includes('GWM_DD_JYFX_HH')) {
          this.selectedPage(0, this.navList[0])
          this.navList[0]['show'] = true
        } else if (data.includes('GWM_DD_JYFX_NEWS')) {
          // 新闻
          this.selectedPage(1, this.navList[1])
          if (!this.hasEnterNewsDatail) {
            this.selectedPage(1, this.navList[1])
          }
        } else if (data.includes('GWM_DD_JYFX_YX')) {
          this.selectedPage(2, this.navList[2])
        } else if (data.includes('GWM_DD_JYFX_BD')) {
          this.selectedPage(3, this.navList[3])
        } else if (data.includes('GWM_DD_JYFX_YX_HW')) {
          this.selectedPage(4, this.navList[4])
        } else if (data.includes('GWM_DD_JYFX_CW')) {
          this.selectedPage(5, this.navList[5])
        } else if (data.includes('GWM_DD_JYFX_SC')) {
          this.selectedPage(6, this.navList[6])
        } else {
          Dialog.alert({
            title: '提示',
            message: '当前用户无权限，请退出'
          }).then(() => {
            // on close
            dd.biz.navigation.close()
          })
        }
        if (data.includes('GWM_DD_JYFX_NEWS')) {
          this.navList[1]['show'] = true
        }
        if (data.includes('GWM_DD_JYFX_YX')) {
          this.navList[2]['show'] = true
        }
        /**
         * 包含新模块
         */
        if (data.includes('GWM_DD_JYFX_BD')) {
          this.navList[3]['show'] = true
        }
        if (data.includes('GWM_DD_JYFX_YX_HW')) {
          this.navList[4]['show'] = true
        }
        if (data.includes('GWM_DD_JYFX_CW')) {
          this.navList[5]['show'] = true
        }
        if (data.includes('GWM_DD_JYFX_SC')) {
          this.navList[6]['show'] = true
        }
        // navList: [{ name: '营销', url: '/' },, { name: '生产', url: '/production' }]
        this.$store.commit('updateEnterNewsDatail', false)
      }
    }
  },
  created () {
    if (!this.$store.state.isOpenNewsDetail) {
      this.isAuthority()
    } else {
      this.$router.replace({ path: '/news', query: { isRouterReplace: true } })
    }
    this.activeIndex = this.navIndex
  }
}
</script>

<style lang="scss" scoped>
.head-nav-content {
  width: 95%;
  overflow-x: hidden;
  margin: 0 auto;
  height: px2rem(88);
  // background-color: #052057;
  // border-bottom: 1px solid #3C6BC8;
  position: relative;
  // &:after {
  //     display: block;
  //     content: "";
  //     position: absolute;
  //     bottom: 0;
  //     width: 100%;
  //     left: 0.26667rem;
  //     // transform: translateX(-50%);
  //     margin: 0 auto;
  //     border-radius: px2rem(100);
  //     border-bottom: 1px solid #2EAFFF;
  //   }
  box-sizing: border-box;
  display: flex;
  // justify-content: space-around;
  .head-nav-content__barimg {
    position: absolute;
    bottom: 0;
    height: 2px;
    width: 200vw;
    left: 0;
    transform: translateX(-44%);
  }
  .item-content {
    width: px2rem(200);
    height: 100%;
    position: relative;
    .name-content {
      width: auto;
      line-height: px2rem(86);
      white-space: nowrap;
      text-align: center;
      font-family: PingFangSC-Regular;
      font-size: px2rem(32);
      color: #3e72ce;
    }
    .active {
      // border-bottom: px2rem(2) solid #fff;
      color: #fff;
      font-size: px2rem(36);
      font-weight: 600;
      // margin: 0 px2rem(60);
      position: relative;
      &.longtxt {
        &:after {
          width: px2rem(80);
        }
      }
      &:after {
        display: block;
        content: '';
        position: absolute;
        bottom: -2px;
        width: px2rem(80);
        left: 50%;
        transform: translateX(-50%);
        margin: 0 auto;
        border-radius: px2rem(150);
        // border-bottom: 3px solid #2EAFFF;
        background: #2eafff;
        height: 4px;
        z-index: 88;
        // background: require('./Icon/linebar.png');
      }
    }
  }
}
</style>
